<div class="header">
  <div class="header-left-content">
    @if (showBackButton) {
      <button
        class="back-icon popup-button"
        (click)="onBackClick()"
        >
        <tun-back-arrow-icon></tun-back-arrow-icon>
      </button>
    }

    <ng-content></ng-content>
  </div>

  <div class="header-right-content">
    <!-- Use the mat-dialog-close directive if we are in a dialog, else a close button which emits the event -->
    @if (isInMatDialog) {
      <button mat-dialog-close class="mat-close-icon popup-button">
        <tun-close-icon></tun-close-icon>
      </button>
    } @else {
      <button class="close-icon popup-button" (click)="onCloseClick()">
        <tun-close-icon></tun-close-icon>
      </button>
    }
  </div>
</div>


